<template>
  <div id="mb-info">
    <div class="mb-info-container">
      <div class="icon-container" @mouseenter="exitHover = true" @mouseleave="exitHover = false">
        <img draggable="false" class="controll-icon" @click="closeInfo()" :src="exitIcon" />
        <transition name="icon-fade">
          <img draggable="false" v-if="exitHover" class="controll-icon" @click="closeInfo()" :src="exitIconOn" />
        </transition>
      </div>
      <div class="line">
        <img draggable="false" class="text-icon" :src="infoIconOn" />
        <span class="title bold">Cele ćwiczenia</span>
      </div>
      <div class="line">
        <span class="text" v-html="info"></span>
      </div>
      <br v-if="copyright" />
      <div class="line" v-if="copyright">
        <span class="text bold">Wykaz dysponentów praw autorskich w&nbsp;multibooku</span>
      </div>
      <br v-if="copyright" />
      <div class="line" v-if="copyright">
        <span class="text bold blue">{{ gameData.id }}</span>
      </div>
      <div class="line" v-if="copyright">
        <span class="text" v-html="copyright"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  name: 'mb-info',
  components: {},
  data: function () {
    return {
      exitHover: false,
      info: null,
      copyright: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.gameData.item) {
        if (this.gameData.item.info) this.info = this.gameData.item.info;
        if (this.gameData.item.copyright) this.copyright = this.gameData.item.copyright;
      }
    },
    closeInfo() {
      this.$emit('closeInf');
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    gameData() {
      return this.$store.getters.gameData;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log('%cExitIcon MbInfo- error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbInfo- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    infoIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/info-on-64px.png`);
      } catch {
        console.log(
          '%cInfoIconOn MbInfo- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-info
  position: fixed
  top: 0
  left: -50%
  width: 150%
  height: 100%
  background: rgba(0,0,0,.5)
  z-index: 6
  display: flex
  justify-content: flex-end
  align-items: flex-start
  color: black
  font-family: $gameFontFamily
  .mb-info-container
    border-radius: 10px
    position: relative
    width: 680px
    margin: 100px 180px
    background: white
    padding: 20px
    text-align: left
    .icon-container
      top: 10px
      right: 10px
      position: absolute
      .controll-icon
        width: 32px
        height: 32px
        top: 10px
        right: 10px
        position: absolute
        transition: .5s
        // transform: scale(.9)
        cursor: pointer
    .line
      display: flex
      justify-content: flex-start
      align-items: center
      .text-icon
        margin-right: 10px
        width: 48px
        height: 48px
      .title
        font-size: 26px
      .text
        font-size: 20px
      .bold
        font-weight: bold
      .blue
        color: #044a9d

.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
